import { formatPrice } from 'utils';

const ProductSelectItem: React.FC<{
  imageUrl?: string;
  name?: string;
  price?: number;
  quantity?: number;
  brand?: string;
  category?: string;
  code?: string;
}> = ({ imageUrl, name, price, quantity, brand, category, code }) => {
  return (
    <div>
      <div className='flex items-center gap-2'>
        {imageUrl && <img src={imageUrl} alt={name} className='w-8 h-8 rounded-md object-cover' />}
        <div className='flex flex-col'>
          <span className='text-sm font-medium'>
            {name} - {code}
          </span>
          <span className='text-xs text-gray-500'>Thương hiệu: {brand || '---'}</span>
          <span className='text-xs text-gray-500'>Danh mục: {category || '---'}</span>
          <span className='text-xs text-gray-500'>Giá: {price ? `${formatPrice(price)} VNĐ` : '---'}</span>
          <span className='text-xs text-gray-500'>Số lượng: {quantity || 0}</span>
        </div>
      </div>
    </div>
  );
};
export default ProductSelectItem;
